export default "__VITE_ASSET__84fff4b0__"